interface KindToType {
  'string[]': string[];
  string: string;
  number: number;
  Date: Date;
}
type AllowedValueKind = keyof KindToType;
type TypesFromKinds<K extends AllowedValueKind[]> = KindToType[K[number]];

export function validateAllowedValue<K extends AllowedValueKind[]>(
  value: unknown,
  types?: [...K]
): value is TypesFromKinds<K> {
  return (types ?? ['string[]', 'string', 'number', 'Date']).some((type) => {
    if (type === 'string[]') {
      return (
        Array.isArray(value) &&
        value.every((valueElement) => typeof valueElement === 'string')
      );
    }

    if (type === 'string') {
      return typeof value === 'string';
    }

    if (type === 'number') {
      return (
        typeof value === 'number' && Math.abs(value) <= Number.MAX_SAFE_INTEGER
      );
    }

    if (type === 'Date') {
      return value instanceof Date;
    }

    return false;
  });
}
